import { ProfileSkeleton } from '@/components/shared/profile-form/skeleton';
import { SidebarSkeleton } from '@/components/shared/sidebar-skeleton';

const Loader = () => (
  <div className="max-w-[1920px] mx-auto">
    <SidebarSkeleton />
    <div className="relative pt-6 px-8 pb-12 ml-[303px]">
      <ProfileSkeleton />
    </div>
  </div>
);

export { Loader };
